module.exports = __webpack_public_path__ + "static/media/ru.72e6fe53.svg";